export default function clearTags() {
  return {
    type: "CLEAR_TAGS",
  };
}
